import firebase from 'src/firebase';
import { SnackbarProvider } from 'notistack';
import React, { useEffect } from 'react';
import { IntlProvider } from 'react-intl';
import { messages } from 'src/messages/messages';
import { getStorage, connectStorageEmulator } from 'firebase/storage';
import { getFunctions, connectFunctionsEmulator } from 'firebase/functions';
import { PrismicPreviewProvider } from 'gatsby-plugin-prismic-previews';
import { Script } from 'gatsby';
import { CookiesProvider } from 'react-cookie';
import { getFirestore } from 'firebase/firestore';
import V1MigrationNotice from 'src/components/global/V1MigrationNotice';

export const wrapRootElement = ({ element }) => (
  <PrismicPreviewProvider>
    <IntlProvider locale="en" messages={messages}>
      <CookiesProvider>
        <SnackbarProvider>
          {element}
          <V1MigrationNotice />
        </SnackbarProvider>
      </CookiesProvider>
    </IntlProvider>
  </PrismicPreviewProvider>
);

const PageWrapper = ({ element }) => {
  useEffect(() => {
    if (!firebase) {
      console.log('no firebase');
      return;
    }

    // Safe to access window here since useEffect only runs client-side
    if (typeof window !== 'undefined' && window.location.hostname === 'localhost') {
      console.log(
        'localhost detected! using emulated firestore running on port 8080 and emulated auth running on port 9099...'
      );
      const db = getFirestore(firebase);
      if (!db._settingsFrozen) {
        const storage = getStorage(firebase);
        connectStorageEmulator(storage, 'localhost', 9199);
        try {
          firebase.firestore().useEmulator('localhost', 8080);
          firebase.auth().useEmulator('http://localhost:9099/');
          const functions = getFunctions(firebase);
          connectFunctionsEmulator(functions, 'localhost', 5001);
        } catch (e) {
          console.log('Error', e);
        }
      }
    }
  }, []);

  return element;
};

export const wrapPageElement = ({ element }) => (
  <>
    <PageWrapper element={element} />
    {process.env.GATSBY_GA_MEASUREMENT_ID && (
      <>
        <Script
          strategy="post-hydrate"
          async
          src={`https://www.googletagmanager.com/gtag/js?id=${process.env.GATSBY_GA_MEASUREMENT_ID}`}
        />
        <Script
          id="gtag-init"
          strategy="post-hydrate"
          dangerouslySetInnerHTML={{
            __html: `
              (function(){
                if (window.gtagInitialized) return;
                window.dataLayer = window.dataLayer || [];
                function gtag(){dataLayer.push(arguments);}
                window.gtag = gtag;
                gtag('js', new Date());
                gtag('config', '${process.env.GATSBY_GA_MEASUREMENT_ID}', { anonymize_ip: true });
                window.gtagInitialized = true;
              })();
            `,
          }}
        />
      </>
    )}
  </>
);
